import axios, { AxiosResponse } from 'axios';

function isRetryable(err: unknown): boolean {
  const e = err as {
    code?: string;
    message?: string;
    response?: { status?: number };
  };
  if (!e) return false;
  const code = e.code;
  if (code === 'ECONNABORTED' || code === 'ERR_NETWORK') return true;
  if (typeof e.message === 'string' && e.message.includes('Network Error')) return true;
  const st = e.response?.status;
  if (st === 502 || st === 503 || st === 504) return true;
  return false;
}

export async function axiosPostWithRetry<T = unknown>(
  url: string,
  body: unknown,
  opts?: { retries?: number; baseDelayMs?: number }
): Promise<AxiosResponse<T>> {
  const retries = opts?.retries ?? 3;
  const base = opts?.baseDelayMs ?? 1000;
  let lastErr: unknown;
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      return await axios.post<T>(url, body);
    } catch (err) {
      lastErr = err;
      if (!isRetryable(err) || attempt === retries - 1) {
        throw err;
      }
      await new Promise((r) => setTimeout(r, base * Math.pow(2, attempt)));
    }
  }
  throw lastErr;
}
